/* istanbul ignore file */
export { CookiesModule } from './cookies.module';
export { CookiesService } from './service/cookies.service';
export { MockCookiesService } from './service/cookies.service.mock';
export { CookieOptions } from './cookies.options';
